/* eslint-disable no-undef */
import {
    Button,
    Menu,
    MenuItem,
    MenuList,
    MenuPopover,
    MenuTrigger,
    SplitButton,
} from "@fluentui/react-components";
import { ENV_SF_CLIENT_ID, ENV_SF_REDIRECT_URI } from "../AdminConstant";

// 🔐 Generate secure random string
const generateRandomString = (length = 64) => {
    const array = new Uint8Array(length);
    window.crypto.getRandomValues(array);
    return btoa(String.fromCharCode(...array))
        .replace(/\+/g, "-")
        .replace(/\//g, "_")
        .replace(/=+$/, "");
};

// 🔐 Generate SHA256 hash
const sha256 = async (plain) => {
    const encoder = new TextEncoder();
    const data = encoder.encode(plain);
    const hash = await crypto.subtle.digest("SHA-256", data);
    return btoa(String.fromCharCode(...new Uint8Array(hash)))
        .replace(/\+/g, "-")
        .replace(/\//g, "_")
        .replace(/=+$/, "");
};

export default function SalesforceConnectButton({ children }) {
    const handleConnect = async (sfEnv = "prod") => {
        const clientId = ENV_SF_CLIENT_ID;
        const redirectUri = ENV_SF_REDIRECT_URI;

        // 🔐 PKCE
        const codeVerifier = generateRandomString(64);
        const codeChallenge = await sha256(codeVerifier);

        localStorage.setItem("sf_pkce_verifier", codeVerifier);
        // STORE SF prod or sandbox
        localStorage.setItem("sf_env", sfEnv);
        //  Environment-based domain
        const baseUrl =
            sfEnv === "sandbox"
                ? "https://test.salesforce.com"
                : "https://login.salesforce.com";

        const url =
            `${baseUrl}/services/oauth2/authorize?` +
            `response_type=code` +
            `&client_id=${clientId}` +
            `&redirect_uri=${encodeURIComponent(redirectUri)}` +
            `&code_challenge=${codeChallenge}` +
            `&code_challenge_method=S256` +
            `&prompt=login`;

        window.location.href = url;
    };
    // If custom children provided → render custom button
    if (children) {
        return (
            <Menu positioning="below-end">
                <MenuTrigger disableButtonEnhancement>
                    {(triggerProps) => (
                        <div
                            {...triggerProps}
                            style={{ display: "inline-flex", cursor: "pointer" }}
                        >
                            {children}
                        </div>
                    )}
                </MenuTrigger>

                <MenuPopover>
                    <MenuList>
                        <MenuItem onClick={() => handleConnect("prod")}>
                            Connect Production
                        </MenuItem>

                        <MenuItem onClick={() => handleConnect("sandbox")}>
                            Connect Sandbox
                        </MenuItem>
                    </MenuList>
                </MenuPopover>
            </Menu>
        );
    }

    return (
        <Menu positioning="below-end">
            <MenuTrigger disableButtonEnhancement>
                {(triggerProps) => (
                    <SplitButton
                        appearance="primary"
                        menuButton={triggerProps}
                        primaryActionButton={{
                            onClick: () => handleConnect("prod"),
                        }}
                    >
                        Connect Salesforce
                    </SplitButton>
                )}
            </MenuTrigger>

            <MenuPopover>
                <MenuList>
                    <MenuItem onClick={() => handleConnect("sandbox")}>
                        Connect Sandbox
                    </MenuItem>
                </MenuList>
            </MenuPopover>
        </Menu>
    );
}
